import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { IPublicClientApplication } from '@azure/msal-browser';
import { Header } from './components/Header';
import { ConversationRecorder } from './components/ConversationRecorder';
import { LoginView } from './components/LoginView';
import './App.css';

interface AppProps {
  msalInstance: IPublicClientApplication;
}

function App({ msalInstance }: AppProps) {
  return (
    <MsalProvider instance={msalInstance}>
      <div className="app">
        <AuthenticatedTemplate>
          <Header />
          <main className="app-content">
            <div className="container">
              <ConversationRecorder />
            </div>
          </main>
        </AuthenticatedTemplate>

        <UnauthenticatedTemplate>
          <LoginView />
        </UnauthenticatedTemplate>
      </div>
    </MsalProvider>
  );
}

export default App;